const host = location.toString();

let hostName = "";
let clientId = "";
let redirectUri = "";
let apiURL = "";

if (host.includes("localhost") || host.includes("dev-")) {
  hostName = process.env.VUE_APP_COGNITO_HOST_NAME_DEV;
  clientId = process.env.VUE_APP_COGNITO_CLIENT_ID_DEV;
  redirectUri = process.env.VUE_APP_COGNITO_REDIRECT_URI_DEV;
  apiURL = process.env.VUE_APP_BACKEND_API_DEV;
} else {
  hostName = process.env.VUE_APP_COGNITO_HOST_NAME;
  clientId = process.env.VUE_APP_COGNITO_CLIENT_ID;
  redirectUri = process.env.VUE_APP_COGNITO_REDIRECT_URI;
  apiURL = process.env.VUE_APP_BACKEND_API;
}

export default {
  hostName,
  clientId,
  responseType: process.env.VUE_APP_COGNITO_RESPONSE_TYPE as string,
  scope: process.env.VUE_APP_COGNITO_SCOPE as string,
  redirectUri,
  apiURL,
  qsApiUrl: process.env.VUE_APP_QS_API as string
};
